import { AxiosError } from 'axios';
import instance from '../config/axios';

export const createPackSlip = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      url: `/api/v1/order-details/${orderId}/packing-slip`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob',
    });

    return { status: response.status, data: response.data };
  } catch (e) {
    console.log(e);
    const error = e as AxiosError;
    return {
      status: error.response?.status,
      message: 'Unable to create the packing slip.',
    };
  }
};
